const createManagementUser = async (
	token: string,
	companyId: string,
	email: string,
	name: string,
	phone?: string
) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/${companyId}/management`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({ email, name, ...(phone && { phone }) })
	});

	if (!response.ok) {
		const errorBody = await response.json().catch(() => ({}));
		throw new Error(errorBody.message || `Error ${response.status}`);
	}

	return response.json();
};

export default createManagementUser;
